// extracted by mini-css-extract-plugin
export default {"black":"#000","primary":"#49aada","orange":"#eb9412","root":"d_85mZGXTT4BjxkeJ7KJ","shadowSmall":"SNv1MiVHYsBt5hA5fH7z"};